import { useFetch } from 'common/hooks';
import { customStopLossRepository } from 'common/repositories';

export type CustomStopLossFetchArgs = Parameters<
  typeof customStopLossRepository.getCustomStopLosses
>[0];

export const useFetchCustomStopLossWithTimer = (
  args: CustomStopLossFetchArgs
) => {
  const { data, ...hook } = useFetch(
    customStopLossRepository.getCustomStopLosses,
    {
      instantFetch: true,
      args,
    }
  );

  return { data: data?.data, ...hook };
};

export type CancelCustomStopLossArgs = Parameters<
  typeof customStopLossRepository.cancelCustomStopLoss
>[0];

export const useCancelCustomStopLoss = (args: CancelCustomStopLossArgs) => {
  const { data, ...hook } = useFetch(
    customStopLossRepository.cancelCustomStopLoss,
    {
      instantFetch: false,
      args,
    }
  );

  return { data: data?.data, ...hook };
};
